import { render, staticRenderFns } from "./MList.vue?vue&type=template&id=3b5cb5aa&lang=html"
import script from "./MList.vue?vue&type=script&lang=js"
export * from "./MList.vue?vue&type=script&lang=js"
import style0 from "./MList.vue?vue&type=style&index=0&id=3b5cb5aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports